import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/shared/api-client'
import { getFollowedUsers } from 'data/api'
import { transformUsersResponse } from 'data/api/transformers/response/transform-users-response'

const DEFAULT_PER_PAGE = 30

const useFetchUsers = (userId: number, page: number) => {
  const {
    fetch: fetchUsers,
    transformedData: data,
    isLoading,
    error,
  } = useFetch(getFollowedUsers, transformUsersResponse, {
    clearDataOnFetch: true,
  })

  useEffect(() => {
    fetchUsers({ userId, perPage: DEFAULT_PER_PAGE, page })
  }, [fetchUsers, userId, page])

  return {
    fetchUsers: (args: Omit<Parameters<typeof fetchUsers>[0], 'perPage'>) => {
      fetchUsers({
        ...args,
        perPage: DEFAULT_PER_PAGE,
      })
    },
    data,
    isLoading: isLoading || (!data && !error),
    error,
    userId,
  }
}

export default useFetchUsers
